// src/ThreeJs/SetUps/enableSphereDrawing.js
import * as THREE from 'three';
import { TransformControls } from 'three/examples/jsm/controls/TransformControls.js';
import { TREESPHERES } from '../Global/variables';

export function enableSphereDrawing(scene, camera, renderer, targetMeshes, setRemovedSections) {
  const raycaster = new THREE.Raycaster();
  const mouse = new THREE.Vector2();
  let drawingMode = true;

  console.log("✅ Sphere drawing mode enabled.");

  // Attach transform controls to sphere (only one active)
  function attachControlsToSphere(sphere) {
    if (!sphere) return;

    // remove previous controls
    if (window.transformControls) {
      window.transformControls.detach();
      if (scene.children.includes(window.transformControls)) {
        scene.remove(window.transformControls);
      }
      window.transformControls.dispose?.();
      window.transformControls = null;
    }

    // create new transform controls
    const transformControls = new TransformControls(camera, renderer.domElement);
    transformControls.attach(sphere);
    transformControls.setMode("translate");
    transformControls.addEventListener("dragging-changed", (e) => {
      const orbit = scene.userData.orbitControls;
      if (orbit) orbit.enabled = !e.value;
    });

    scene.add(transformControls);
    window.transformControls = transformControls;

    // keyboard shortcuts
    window.addEventListener("keydown", (event) => {
      if (!window.transformControls) return;
      if (event.key.toLowerCase() === "t") window.transformControls.setMode("translate");
      if (event.key.toLowerCase() === "s") window.transformControls.setMode("scale");
    });

    if (scene.userData.orbitControls) window.orbitControls = scene.userData.orbitControls;
    console.log(`🎮 Controls attached to ${sphere.name}`);
  }

  // helper to remove sphere and controls
  window.removeSphereAndControls = (sphere) => {
    if (!sphere) return;

    scene.remove(sphere);
    sphere.geometry?.dispose();
    sphere.material?.dispose();

    setRemovedSections((prev) => ({
      ...prev,
      spheres: prev.spheres.filter((s) => s !== sphere),
    }));

    if (window.transformControls?.object === sphere) {
      window.transformControls.detach();
      scene.remove(window.transformControls);
      window.transformControls.dispose?.();
      window.transformControls = null;
      console.log("🧹 Transform controls removed.");
    }

    if (window.orbitControls) window.orbitControls.enabled = true;
  };

  // expose to global so sidebar can call it
  window.attachControlsToSphere = attachControlsToSphere;

  // handle click to create sphere
  function onClick(event) {
    if (!drawingMode) return;
    drawingMode = false;

    const rect = renderer.domElement.getBoundingClientRect();
    mouse.x = ((event.clientX - rect.left) / rect.width) * 2 - 1;
    mouse.y = -((event.clientY - rect.top) / rect.height) * 2 + 1;

    raycaster.setFromCamera(mouse, camera);
    const intersects = raycaster.intersectObjects(
      Array.isArray(targetMeshes) ? targetMeshes : [targetMeshes],
      true
    );
    if (intersects.length === 0) return;
    const point = intersects[0].point;

    const sphere = new THREE.Mesh(
      new THREE.SphereGeometry(1, 32, 32),
      new THREE.MeshBasicMaterial({
        color: 0x00ff00,
        wireframe: true,
        opacity: 0.6,
        transparent: true,
      })
    );
    sphere.position.copy(point);
    sphere.name = `InteractiveSphere_${Date.now()}`;
    sphere.userData.mode = "translate";
    scene.add(sphere);

    TREESPHERES.spheres.push(sphere);
    setRemovedSections((prev) => ({
      ...prev,
      spheres: [...prev.spheres, sphere],
    }));

    attachControlsToSphere(sphere);
  }

  renderer.domElement.addEventListener("click", onClick, { once: true });
}
